/** Warm accent tokens for specialty contractor cards (pairs with QwikFix cyan) */
export const SPECIALTY_BRAND = {
  gold: '#f5a524',
  goldBorder: '#fde7b8',
  goldBorderHover: '#fbd784',
  amberText: '#8a5a00',
  cardGradient:
    'linear-gradient(160deg, #ffffff 0%, #fffefb 55%, #fffbf6 100%)',
  glowWarm: 'rgba(245, 165, 36, 0.06)',
  glowSoft: 'rgba(253, 231, 184, 0.12)',
} as const;
